import {
  TextInput,
  TextInputProps,
  useMantineColorScheme,
} from "@mantine/core";
import { formatDate } from "common/utils";
import { useEffect, useRef, useState } from "react";

interface CustomInputProps extends Omit<TextInputProps, "value" | "onChange"> {
  readonlyMode: boolean;
  value: string;
  asDate?: boolean;
  onChange?: (value: string) => void;
}

export const CustomInput: React.FC<CustomInputProps> = ({
  readonlyMode,
  value,
  asDate = false,
  onChange,
  styles,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [localValue, setLocalValue] = useState(value ?? "");

  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const labelColor = isDark ? "#e0e0e0" : "#1a1a1a";

  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  const handleBlur = () => {
    let v = localValue ?? "";

    if (asDate && v) {
      v = formatDate(v);
    }

    onChange && onChange?.(v);
  };

  return (
    <TextInput
      readOnly={readonlyMode}
      ref={inputRef}
      value={localValue}
      onChange={(e) => setLocalValue(e.currentTarget.value)}
      onBlur={handleBlur}
      labelProps={{
        fw: 600,
        size: "lg",
        style: { color: labelColor },
      }}
      styles={{
        input: {
          backgroundColor: readonlyMode
            ? isDark
              ? "#2a2a2a"
              : "#f5f5f5"
            : isDark
              ? "#3a3a3a"
              : "white",

          borderColor: readonlyMode
            ? isDark
              ? "#555"
              : "#d0d0d0"
            : isDark
              ? "#4dabf7"
              : "#228be6",

          cursor: readonlyMode ? "default" : "text",
          // transition: "background-color 120ms ease, border-color 120ms ease",
        },
        ...styles,
      }}
      {...rest}
    />
  );
};
